import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Layout from "./components/Layout/Layout";
import { ChakraProvider } from "@chakra-ui/react";

ReactDOM.render(
  <React.StrictMode>
    <ChakraProvider>
      <Layout />
    </ChakraProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
